<template>
    <div class="table_wrap">
        <el-table :data="historyData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  @selection-change="tableSelectChange"
                  height="695"
        >
            <el-table-column
                    type="selection"
                    class-name="text-center"
                    min-width="25">
            </el-table-column>
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    min-width="45"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="내용" min-width="155" class-name="text-center">
                <template slot-scope="scope">
                    <span v-html="parsingBr(scope.row.ch_content)">
<!--                        {{parsingBr(scope.row.ch_content)}}-->
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="연혁일" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.ch_date, 'YYYY-MM-DD')}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="작성일자" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.created_at, 'YYYY-MM-DD HH:mm')}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="상세" width="90" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goDetail(scope.row.ch_idx)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    export default {
        name: "HistoryListDefaultLayout",
        mixins: [],
        components: {},
        inject: {
            setPage: {default: () => {}},
            historyListSetData: {default: () => {}},
            setFilter: {default: () => {}},
        },
        provide() {
            return {}
        },
        props: {
            historyData: {default: () => {return []}},
            paginationData: {
                default: () => { return { total: 0, page: 0, size: 0, }}
            },
        },
        data() {
            return {}
        },
        created() {},
        mounted() {},
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
            tableSelectChange(row) {
                this.selectArr = [];
                util.Array.each(row, (obj, index, arr) => {
                    this.selectArr.push(obj.ch_idx);
                });
                this.historyListSetData('selectArr', this.selectArr)
            },
            returnDate(date = null, format='YYYY-MM-DD HH:mm') {
                if (!date) {
                    return '';
                }
                return this.$moment(date).format(format)
            },
            goDetail(key){
                this.$router.push(`${this.$route.path}/${key}`);
            },

            parsingBr(content) {
                return util.isEmpty(content) ?  "" : content.replaceAll("\n", '<br>');
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
